import { render, staticRenderFns } from "./DialogReviewPendingMems.vue?vue&type=template&id=62e548d6"
import script from "./DialogReviewPendingMems.vue?vue&type=script&lang=js"
export * from "./DialogReviewPendingMems.vue?vue&type=script&lang=js"
import style0 from "./DialogReviewPendingMems.vue?vue&type=style&index=0&id=62e548d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports